module.exports = {
  urls: {
    api: 'https://api.clinmarket.ru/admin/',
  },
};
